module.exports = __webpack_public_path__ + "media/images/icons/outlined/fork-998752353fb3bc3169df2ebf58f2e20c.svg";